import React from "react";
import { memo } from "react";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CadastroViagem from "../Embarque/StepperV2/CadastroViagem.js";
import { useNavigate } from "react-router-dom";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";

function CadastrarModeloViagens() {
	const navigate = useNavigate();

	return (
		<div className="layout-container">
			<NavbarV3 title="Cadastro de Viagens - Modelo Viagens"/>
			<div className="indicadores">
				<div className="texto-cadastro">
					<p className="indicador-emb">{"Dados do Modelo / "}</p>
					<p className="indicador-emb">Cadastro de Modelo de Viagens</p>
					<HeaderCadastro texto="" />
				</div>
				<div className="close-btn">
					<CloseIcon
						onClick={() => {
							navigate("/modelo-viagens");
						}}
					/>
				</div>
			</div>
			<CadastroViagem />
		</div>
	);
}

export default memo(CadastrarModeloViagens);
